import { useTranslation } from "react-i18next"
import { CatalogItemEntity } from "../../Objects/ProductsAndCatalogItems/CatalogItemEntity"
import { catalogItemsMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"

export const useGetCatalogItems = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetCatalogItems = async (onSuccess: any, rote: string = API_ROUTES.CATALOG_ITEM.GET_ALL) => {
    enableLoad()
    try {
      const response = await GetRequest<CatalogItemEntity[]>(rote)

      if (response.success) {
        const temp = response.data?.map((ss) => new CatalogItemEntity(ss)) ?? []

        catalogItemsMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetCatalogItems,
  }
}
